import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavItem = ({ href, faIcon, label, active, onClick }) => {
    return (
        <li className={`nav-item ${active ? 'active' : ''}`} onClick={onClick}>
            <Link to={href} className="nav-link">
                <FontAwesomeIcon icon={faIcon} fixedWidth /> {label}
            </Link>
        </li>
    );
};

export default NavItem;
